var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 24.188c0 21.11-36 44.147-36 44.147S0 45.218 0 24.188C0 3.158 19.673-3.826 36 10.623c14.336-14.69 36-7.546 36 13.565z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNzIgNzIiIGZpbGw9ImN1cnJlbnRDb2xvciIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTcyIDI0LjE4NzZDNzIgNDUuMjk3OSAzNiA2OC4zMzQ1IDM2IDY4LjMzNDVDMzYgNjguMzM0NSAwIDQ1LjIxNzYgMCAyNC4xODc2QzAgMy4xNTc2MyAxOS42NzI2IC0zLjgyNTYxIDM2IDEwLjYyMjVDNTAuMzM2MyAtNC4wNjY0MSA3MiAzLjA3NzM2IDcyIDI0LjE4NzZaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { SvgFavOn as ReactComponent };